import { hasPartnerDashboardAccess } from "helpers/auth";
import gtagEventEmitter from "helpers/gtagEventEmitter";
import { identifyPostHogUserByEmail } from "@Utils/posthog";
import customWindowLocation from "@Utils/customWindowLocation";

const loginSuccess = (data: any, loginType: any, nextRoute: any) => {
  identifyPostHogUserByEmail(data?.email, {
    funnel: "login",
    login_type: loginType,
    user_id: data?.id,
    name: data?.name,
    phone: data?.phone,
  });

  // Google Analytics
  gtagEventEmitter({
    action: "success",
    category: "login",
    label: loginType,
    email_id: data?.email,
  });

  if (typeof window !== "undefined") {
    // @ts-ignore
    if (data?.user_auth_token && window.wx && window.wx.miniProgram) {
      // Send user auth token to mini program after login
      // @ts-ignore
      window.wx.miniProgram.postMessage({
        data: [
          {
            type: "USER_AUTH_TOKEN",
            user_auth_token: data.user_auth_token,
            timestamp: Date.now(),
          },
        ],
      });
    }
    const isConnectRoute = window.location.pathname?.includes("/list");
    if (isConnectRoute) {
      (async () => {
        try {
          const userAuthToken = data?.user_auth_token;
          const isPartnerLoginSuccess = await hasPartnerDashboardAccess(
            userAuthToken,
            "api/v0/auth/providers/users",
          );
          if (isPartnerLoginSuccess) {
            gtagEventEmitter({
              action: isConnectRoute ? "provider_login_success" : "partner_login_success",
              category: "login",
              label: loginType,
              email_id: data?.email,
            });
          }
        } catch (error) {
          console.log("Error occured while checking partner dashboard access", error);
        }
      })();
    }
  }

  // Redirect to route on login or reload to set the login cookie
  if (nextRoute) {
    customWindowLocation({ url: `${nextRoute}` });
  } else {
    window.location.reload();
  }
};

export default loginSuccess;
